import { useEffect, useState } from "react";
import { fetchApi } from "../../config";

function ContactIcon({ type }) {
  if (type === "email") {
    return (
      <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
        <rect height="16" rx="2" stroke="currentColor" strokeWidth="1.7" width="20" x="2" y="4" />
        <path d="m3 6 9 7 9-7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
      </svg>
    );
  }

  if (type === "location") {
    return (
      <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
        <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
      <path d="M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-5-2-2 2a14 14 0 0 1-8-8l2-2-2-5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
    </svg>
  );
}

export default function ContactInfo() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadContactInfo() {
      try {
        const response = await fetchApi("get_contact_info.php");
        const item = Array.isArray(response.Info) && response.Info[0];
        if (!item) {
          throw new Error("No contact info returned from API.");
        }

        setInfo({
          india: {
            k: "INDIA",
            v: item.contact_primary || item.whatsapp_primary || "",
            sub: item.address_primary || "",
          },
          usa: {
            k: "USA",
            v: item.contact_secondary || "",
            sub: item.address_secondary || "",
          },
          email: {
            k: "EMAIL",
            v: item.email_primary || "",
            v2: item.email_secondary || "",
            sub: item.email_tertiary || "",
            orange: true,
          },
        });
      } catch (err) {
        setError(err.message || "Failed to load contact information.");
      } finally {
        setLoading(false);
      }
    }

    loadContactInfo();
  }, []);

  if (loading) {
    return <div className="contact-info">Loading contact information...</div>;
  }

  if (error) {
    return <div className="contact-info">Error: {error}</div>;
  }

  const blocks = [info.india, info.usa, info.email].filter(Boolean);

  return (
    <div className="contact-info">
      <h2>Talk to us directly.</h2>
      {blocks.map((b) => (
        <div className="block" key={b.k}>
          <div className="k">{b.k}</div>
          {b.v && (
            <div className="contact-info-line">
              <ContactIcon type={b.orange ? "email" : "phone"} />
              <span className={b.orange ? "v orange" : "v"}>{b.v}</span>
            </div>
          )}
          {b.sub && (
            <div className="contact-info-line">
              <ContactIcon type={b.orange ? "email" : "location"} />
              <span className={b.orange ? "v orange" : "sub"}>{b.sub}</span>
            </div>
          )}
          {b.v2 && (
            <div className="contact-info-line">
              <ContactIcon type="email" />
              <span className="v orange">{b.v2}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
